export enum UserLogEventType {
  UserLogin = 'USER_LOGIN',
  UserLogout = 'USER_LOGOUT',
}
